<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('house.modalEditTitle' | t:'Edit House') : ('house.modalNewTitle' | t:'New House') }}</h2>
      </div>

      <form class="house-form" (ngSubmit)="submitForm()" #houseForm="ngForm">
        <div class="form-row">
          <div class="form-group">
            <label>{{ 'house.houseNameOrNumber' | t:'House Name / Number' }} *</label>
            <input
              type="text"
              name="houseName"
              [(ngModel)]="house.name"
              #houseNameModel="ngModel"
              [class.input-error]="(isSubmitted || houseNameModel.touched) && houseNameModel.invalid"
              [placeholder]="'placeholder.typeHouseName' | t:'Type house name'"
              required
            />
            <div class="field-error" *ngIf="(isSubmitted || houseNameModel.touched) && houseNameModel.invalid">
              House name is required.
            </div>
          </div>
          <div class="form-group">
            <label>{{ 'house.address' | t:'Address' }} *</label>
            <input
              type="text"
              name="houseAddress"
              [(ngModel)]="house.address"
              #houseAddressModel="ngModel"
              [class.input-error]="(isSubmitted || houseAddressModel.touched) && houseAddressModel.invalid"
              [placeholder]="'placeholder.typeFullAddress' | t:'Type full address'"
              required
            />
            <div class="field-error" *ngIf="(isSubmitted || houseAddressModel.touched) && houseAddressModel.invalid">
              House address is required.
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group form-group-small">
            <label>{{ 'house.totalFloor' | t:'Total Floor' }} *</label>
            <div class="floor-scale-wrap">
              <button type="button" class="scale-btn" (click)="decreaseFloorCount()">-</button>
              <input
                type="range"
                name="floorCount"
                [(ngModel)]="floorCount"
                [min]="floorMin"
                [max]="floorMax"
                step="1"
                (input)="updateFloors()"
                required
              />
              <button type="button" class="scale-btn" (click)="increaseFloorCount()">+</button>
            </div>
            <div class="floor-scale-value">{{ floorCount }} {{ 'house.floorUnit' | t:'floor' }}</div>
          </div>
        </div>

        <div class="floor-list">
          <div class="floor-card" *ngFor="let floor of floors">
            <label>{{ floor.index }} {{ 'house.floorName' | t:'Floor Name' }}</label>
            <input
              type="text"
              name="floor-{{ floor.index }}"
              [(ngModel)]="floor.name"
              [placeholder]="'placeholder.typeFloorName' | t:'Type name'"
            />
          </div>
        </div>

        <div class="form-actions">
          <div class="form-message error" *ngIf="error">{{ error }}</div>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('house.updateButton' | t:'Update House') : ('house.addButton' | t:'Add House')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
